<template>
  <section>
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input
            v-model="filters.key"
            placeholder="编号/标题/部位/浇筑/工程/客户"
            @change="getTaskList(1)"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.gradeName"
            placeholder="强度等级"
            @change="getTaskList(1)"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.orgCode"
            filterable
            placeholder="请选择"
            @change="selectOrg"
          >
            <el-option
              v-for="item in orgList"
              :key="item.OrgCode + 'Seach'"
              :label="item.Name"
              v-model="item.OrgCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.taskStatus"
            @change="getTaskList(1)"
            placeholder="任务状态"
          >
            <el-option label="所有" :value="-1"></el-option>
            <el-option label="已开盘" :value="0"></el-option>
            <el-option label="未开盘" :value="100"></el-option>
            <el-option label="暂停" :value="200"></el-option>
            <el-option label="完成" :value="300"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            type="datetime"
            placeholder="计划时间"
            v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          -
          <el-date-picker
            type="datetime"
            placeholder="计划时间"
            v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.isRecipe"
            placeholder="请选择状态"
            @change="getTaskList(1)"
          >
            <el-option label="所有" :value="-1"></el-option>
            <el-option label="已做配比" :value="0"></el-option>
            <el-option label="未做配比" :value="100"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getTaskList(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-card
      class="box-card"
      style="width: 98%; margin-top: 5px"
      v-for="item in dataList"
      :key="item.Id"
    >
      <div slot="header" class="clearfix">
        <div>
          <span style="font-size: 15px">
            <span style="color: #595a52">
              <el-tag
                size="small"
                :type="
                  item.TaskStatus == 0
                    ? 'success'
                    : item.TaskStatus == 100
                    ? 'info'
                    : item.TaskStatus == 200
                    ? 'warning'
                    : item.TaskStatus == 300
                    ? ''
                    : 'danger'
                "
              >
                {{
                  item.TaskStatus == 0
                    ? "已开盘"
                    : item.TaskStatus == 100
                    ? "未开盘"
                    : item.TaskStatus == 200
                    ? "暂停"
                    : item.TaskStatus == 300
                    ? "完成"
                    : "未设置"
                }}
              </el-tag>
              任务
            </span>
            ：
            <span style="color: #6bae91">{{ item.Code }}</span>
            <span style="color: #595a52">计划/方量</span>
            ：
            <span style="color: #6bae91">
              {{ item.PlanDate }} / {{ item.PlanQuantity }}
            </span>
            <span style="color: #595a52">工程</span>
            ：
            <span style="color: #c85762">{{ item.ProjectName }}</span>
            <span style="color: #595a52">强度</span>
            ：
            <span style="color: #c29463">
              {{ item.GradeName }} / {{ item.SpecMtlName }}
            </span>
            <span style="color: #595a52">部位</span>
            ：
            <span style="color: #6bae91">{{ item.ProjectPart }}</span>
            <span style="color: #595a52">浇筑方式</span>
            ：
            <span style="color: #c85762">{{ item.WorkMethodName }}</span>
            <span style="color: #595a52">备注</span>
            ：
            <span style="color: #c29463">{{ item.Remark }}</span>
          </span>
          <span style="color: #c85762">{{ item.Memo }}</span>
          <span style="float: right; padding: 3px 0">
            <el-link
              type="primary"
              @click="
                () => {
                  currentRow = item;
                  addProdRecipe();
                }
              "
            >
              绑定配比
            </el-link>
            <el-link
              type="primary"
              @click="
                () => {
                  currentRow = item;
                  copyProdRecipe();
                }
              "
            >
              复制
            </el-link>
          </span>
        </div>
      </div>

      <div
        class="stationline-card"
        v-for="itemStation in item.sysStationLineList"
        :key="itemStation.Id + '_' + item.Id"
      >
        <div>
          <span style="font-size: 12px">
            <span style="color: #6bae91">{{ itemStation.Name }}</span>
            <el-link
              v-if="itemStation.prodRecipeMain != null"
              :type="
                itemStation.prodRecipeMain.Transfer == 1 ? 'success' : 'warning'
              "
              :underline="false"
              style="font-size: 12px; margin-top: -2px; margin-left: 5px"
              @click="sendRecipe(itemStation.prodRecipeMain)"
            >
              {{
                itemStation.prodRecipeMain.Transfer == 0 ? "未传送" : "已传送"
              }}
            </el-link>
          </span>
          <span style="float: right">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-search"
              v-if="
                itemStation.prodRecipeMain != null &&
                itemStation.prodRecipeMain.Id > 0
              "
              @click="
                () => {
                  currentRow = item;
                  showRecipeHistry(itemStation.prodRecipeMain);
                }
              "
            >
              详情
            </el-button>
          </span>
        </div>
        <div style="font-size: 12px; margin-bottom: 5px; margin-top: 12px">
          <span>
            混凝土配比:
            <el-link
              :underline="false"
              type="info"
              style="font-size: 12px; margin-top: -4px"
              v-if="
                itemStation.prodRecipeMain != null &&
                itemStation.prodRecipeMain.Id > 0 &&
                itemStation.prodRecipeMain.TBulkDensity > 0
              "
            >
              {{
                itemStation.prodRecipeMain.TConsultRecipeTitle == null ||
                itemStation.prodRecipeMain.ConsultRecipeTitle == ""
                  ? "自定义配比"
                  : itemStation.prodRecipeMain.TConsultRecipeTitle
              }}
            </el-link>
            <span style="color: #a6a9ad" v-else>未创建</span>
          </span>
          <span
            style="color: #c29463"
            title="A掺量"
            v-if="
              itemStation.prodRecipeMain != null &&
              itemStation.prodRecipeMain.Id > 0
            "
          >
            {{ itemStation.prodRecipeMain.TAProportion }}
          </span>
        </div>
        <div style="font-size: 12px">
          <span>
            砂浆配比:
            <el-link
              :underline="false"
              type="info"
              style="font-size: 12px; margin-top: -4px"
              v-if="
                itemStation.prodRecipeMain != null &&
                itemStation.prodRecipeMain.Id > 0 &&
                itemStation.prodRecipeMain.SBulkDensity > 0
              "
            >
              {{
                itemStation.prodRecipeMain.SConsultRecipeTitle == null ||
                itemStation.prodRecipeMain.SConsultRecipeTitle == ""
                  ? "自定义配比"
                  : itemStation.prodRecipeMain.SConsultRecipeTitle
              }}
            </el-link>
            <span style="color: #a6a9ad" v-else>未创建</span>
          </span>
          <span
            style="color: #c29463"
            title="A掺量"
            v-if="
              itemStation.prodRecipeMain != null &&
              itemStation.prodRecipeMain.Id > 0
            "
          >
            {{ itemStation.prodRecipeMain.SAProportion }}
          </span>
        </div>
      </div>
    </el-card>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="filters.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered" style="">
        <tr>
          <th>任务标题</th>
          <td>{{ taskdM.Title }}</td>
          <th>工程名称</th>
          <td>{{ taskdM.ProjectName }}</td>
        </tr>
        <tr>
          <th>客户名称</th>
          <td>{{ taskdM.ClientName }}</td>
          <th>运输距离</th>
          <td>{{ taskdM.Distance }}</td>
        </tr>
        <tr>
          <th>计划方量</th>
          <td>{{ taskdM.PlanQuantity }}</td>
          <th>计划时间</th>
          <td>{{ taskdM.PlanDate }}</td>
        </tr>
        <tr>
          <th>坍落度</th>
          <td>{{ taskdM.TLD }}</td>
          <th>强度等级</th>
          <td>{{ taskdM.GradeName }} / {{ taskdM.SpecMtlName }}</td>
        </tr>
        <tr>
          <th>是否泵送</th>
          <td>{{ taskdM.IsPumping == 1 ? "是" : "否" }}</td>
          <th>浇筑方式</th>
          <td>{{ taskdM.WorkMethodName }}</td>
        </tr>
        <tr>
          <th>施工地址</th>
          <td>{{ taskdM.ConstructionAddress }}</td>
          <th>施工部位</th>
          <td>{{ taskdM.ProjectPart }}</td>
        </tr>
        <tr>
          <th>联系人</th>
          <td>{{ taskdM.ContactName }}</td>
          <th>联系电话</th>
          <td>{{ taskdM.ContactPhone }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ taskdM.Remark }}</td>
        </tr>
      </table>
    </el-dialog>

    <!-- 添加配比 -->
    <el-dialog
      :title="isEdit ? '编辑配比' : '新增配比'"
      :visible.sync="isShowAddRecipe"
      v-model="isShowAddRecipe"
      :close-on-click-modal="false"
      append-to-body
      width="90%"
    >
      <div>
        <el-divider content-position="left">任务信息</el-divider>
        <table class="table-bordered" style="">
          <tr>
            <th>任务单</th>
            <td>
              {{ taskdM.Title }}-{{ taskdM.Code }}
              <el-button
                type="primary"
                v-if="isCopyTask"
                @click="visibleTaskDialog = true"
              >
                选择
              </el-button>
            </td>
            <th>工程名称</th>
            <td>{{ taskdM.ProjectName }}</td>
          </tr>
          <tr>
            <th>施工部位</th>
            <td>{{ taskdM.ProjectPart }}</td>
            <th>备注</th>
            <td>{{ taskdM.Remark }}</td>
          </tr>
          <tr>
            <th>强度等级</th>
            <td>{{ taskdM.GradeName }}/{{ taskdM.SpecMtlName }}</td>
            <th>浇筑方式</th>
            <td>{{ taskdM.WorkMethodName }}</td>
          </tr>
          <tr>
            <th>坍 落 度</th>
            <td>{{ taskdM.TLD }}</td>
            <th>计划方量/距离</th>
            <td>{{ taskdM.PlanQuantity }} / {{ taskdM.Distance }}</td>
          </tr>
        </table>
        <div style="margin-top: 5px">
          <el-divider content-position="left">生产线</el-divider>
          <el-checkbox-group v-model="checkboxStationLine">
            <el-checkbox
              v-for="station in stationLine"
              @change="addTab(station.Id, $event)"
              :label="station.Name"
              :key="station.Id + 'checkboxStationLine'"
            >
              {{ station.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <el-divider content-position="left">配比信息</el-divider>
        <el-tabs v-model="editableTabsValue" type="card">
          <el-tab-pane
            v-for="item in editableTabs"
            :key="item.prodRecipeMain.StationLineID + 'editableTabs'"
            :label="item.prodRecipeMain.StationLine"
            :name="item.prodRecipeMain.StationLine"
          >
            <el-form
              :inline="true"
              :model="item.prodRecipeMain"
              class="demo-form-inline"
            >
              <h3>
                混凝土配比 -
                {{ item.prodRecipeMain.TConsultRecipeTitle }}
                <el-button
                  type="primary"
                  @click="dialogType(1, item.prodRecipeMain.StationLineID)"
                >
                  选择
                </el-button>
              </h3>
              <el-form-item label="搅拌时间">
                <el-input
                  v-model="item.prodRecipeMain.TMixTime"
                  placeholder="搅拌时间"
                ></el-input>
              </el-form-item>
              <el-form-item label="坍落度">
                <el-select
                  v-model="item.prodRecipeMain.TTLD"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in baseData.TldList"
                    :key="item.Id + '_TldT'"
                    :label="item.Name"
                    :value="item.Name"
                    v-model="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注">
                <el-input
                  v-model="item.prodRecipeMain.TRemark"
                  placeholder="备注"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-button
                  type="primary"
                  v-for="itemStation in editableTabs.filter(
                    (e) =>
                      e.prodRecipeMain.StationLineID !=
                      item.prodRecipeMain.StationLineID
                  )"
                  :key="
                    item.prodRecipeMain.StationLineID +
                    '_copy_' +
                    itemStation.prodRecipeMain.StationLineID
                  "
                  icon="el-icon-share"
                  @click="
                    copyToStationLine(
                      item.prodRecipeMain.StationLineID,
                      itemStation.prodRecipeMain.StationLineID,
                      1
                    )
                  "
                >
                  {{ itemStation.prodRecipeMain.StationLine }}
                </el-button>
              </el-row>
              <el-row
                :gutter="20"
                type="flex"
                justify="space-around"
                class="row-center"
              >
                <el-col>物资类型</el-col>
                <el-col>仓库</el-col>
                <el-col>物资</el-col>
                <el-col>规格</el-col>
                <el-col>理论用量（千克）</el-col>
                <el-col>实际用量（千克）</el-col>
                <el-col>含水率</el-col>
                <el-col>备注</el-col>
                <el-col>操作</el-col>
              </el-row>
              <el-row
                :gutter="20"
                type="flex"
                justify="space-around"
                v-for="(itemSub, index) in item.prodRecipeSubT"
                :key="index + '_T' + item.prodRecipeMain.StationLineID"
              >
                <el-col>
                  <el-form-item>
                    <el-select
                      v-model="itemSub.MatClassName"
                      @change="
                        recipeMappingSelectChange(
                          $event,
                          index,
                          item.prodRecipeMain.StationLineID,
                          1
                        )
                      "
                      :disabled="itemSub.IsManual == 0"
                      filterable
                    >
                      <el-option
                        v-for="mp in MaterialClassList"
                        :label="mp.MatClassName"
                        :key="
                          mp.MatClassID +
                          '_MatClassID_' +
                          index +
                          '_' +
                          item.prodRecipeMain.StationLineID
                        "
                        :value="mp.MatClassID"
                        v-model="mp.MatClassID"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-select
                      v-model="itemSub.WarehouseName"
                      @change="
                        recipeWhSelectChange(
                          $event,
                          index,
                          item.prodRecipeMain.StationLineID,
                          1
                        )
                      "
                      filterable
                    >
                      <el-option
                        v-for="wh in MappingGroupList.filter(
                          (e) =>
                            e.StationLineID == item.prodRecipeMain.StationLineID
                        ).filter((e) => e.MatClassID == itemSub.MatClassID)"
                        :label="wh.WarehouseName"
                        :key="
                          wh.Id +
                          '_WarehouseID_' +
                          index +
                          '' +
                          item.prodRecipeMain.StationLineID
                        "
                        :value="wh.WarehouseID"
                        v-model="wh.WarehouseID"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-select
                      v-model="itemSub.MatName"
                      @change="
                        recipeMatSelectChange(
                          $event,
                          index,
                          item.prodRecipeMain.StationLineID,
                          1
                        )
                      "
                      filterable
                    >
                      <el-option
                        v-for="material in baseData.MaterialList &&
                        baseData.MaterialList.length > 0 &&
                        baseData.MaterialList.filter(
                          (e) => e.MatClassTypeCode == itemSub.MatTypeCode
                        ).length > 0
                          ? baseData.MaterialList.filter(
                              (e) => e.MatClassTypeCode == itemSub.MatTypeCode
                            )
                          : baseData.MaterialList"
                        :label="material.Name + '(' + material.MatGrade + ')'"
                        :key="
                          material.Id +
                          '_material_' +
                          index +
                          '' +
                          item.prodRecipeMain.StationLineID
                        "
                        :value="material.Id"
                        v-model="material.Id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-model="itemSub.MatGrade"
                      auto-complete="off"
                      readonly=""
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-model="itemSub.Quantity"
                      auto-complete="off"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-if="itemSub.Quantity == itemSub.ActualQuantity"
                      v-model="itemSub.ActualQuantity"
                      auto-complete="off"
                      @input="
                        changequantity(item.prodRecipeMain.StationLineID, 1)
                      "
                      :readonly="
                        (itemSub.MatTypeCode == 30 ||
                          itemSub.MatTypeCode == 301 ||
                          itemSub.MatTypeCode == 302) &&
                        itemSub.MoistureContent > 0
                          ? true
                          : false
                      "
                    ></el-input>
                    <el-input
                      v-else
                      DangerColor="danger"
                      v-model="itemSub.ActualQuantity"
                      auto-complete="off"
                      @input="
                        changequantity(item.prodRecipeMain.StationLineID, 1)
                      "
                      :readonly="
                        (itemSub.MatTypeCode == 30 ||
                          itemSub.MatTypeCode == 301 ||
                          itemSub.MatTypeCode == 302) &&
                        itemSub.MoistureContent > 0
                          ? true
                          : false
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-model="itemSub.MoistureContent"
                      auto-complete="off"
                      @input="
                        MoistureContentCalculation(
                          item.prodRecipeMain.StationLineID,
                          1
                        )
                      "
                      v-show="
                        (itemSub.MatTypeCode == 30 ||
                          itemSub.MatTypeCode == 301 ||
                          itemSub.MatTypeCode == 302) &&
                        itemSub.Quantity > 0
                          ? true
                          : false
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input v-model="itemSub.Remark"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item style="text-align: center">
                    <el-button
                      type="danger"
                      @click="
                        recipeTableRemoveRow(
                          index,
                          item.prodRecipeMain.StationLineID,
                          1
                        )
                      "
                      v-show="itemSub.IsManual == 1"
                    >
                      删除
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-button
                  @click="
                    recipeTableAddRow(item.prodRecipeMain.StationLineID, 1)
                  "
                >
                  新增行
                </el-button>
              </el-row>
            </el-form>
            <el-form size="mini">
              <el-row
                :gutter="20"
                type="flex"
                justify="space-around"
                class="row-center"
              >
                <el-col>
                  <el-form-item label="砂率">
                    <el-input v-model="item.prodRecipeMain.TSL"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="水胶比">
                    <el-input v-model="item.prodRecipeMain.TSJB"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="容重">
                    <el-input
                      v-model="item.prodRecipeMain.TBulkDensity"
                      readonly=""
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="F掺量">
                    <el-input
                      v-model="item.prodRecipeMain.TFProportion"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="K掺量">
                    <el-input
                      v-model="item.prodRecipeMain.TKProportion"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="A掺量">
                    <el-input
                      v-model="item.prodRecipeMain.TAProportion"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <el-divider></el-divider>
            <el-form
              :inline="true"
              :model="item.prodRecipeMain"
              class="demo-form-inline"
            >
              <h3>
                砂浆配比 - {{ item.prodRecipeMain.SConsultRecipeTitle }}
                <el-button
                  type="primary"
                  @click="dialogType(2, item.prodRecipeMain.StationLineID)"
                >
                  选择
                </el-button>
              </h3>
              <el-form-item label="搅拌时间">
                <el-input
                  v-model="item.prodRecipeMain.SMixTime"
                  placeholder="搅拌时间"
                ></el-input>
              </el-form-item>
              <el-form-item label="坍落度">
                <el-select
                  v-model="item.prodRecipeMain.STLD"
                  filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in baseData.TldList"
                    :key="item.Id + '_TldT'"
                    :label="item.Name"
                    :value="item.Name"
                    v-model="item.Name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注">
                <el-input
                  v-model="item.prodRecipeMain.SRemark"
                  placeholder="备注"
                ></el-input>
              </el-form-item>
              <el-row>
                <el-button
                  type="primary"
                  v-for="itemStation in editableTabs.filter(
                    (e) =>
                      e.prodRecipeMain.StationLineID !=
                      item.prodRecipeMain.StationLineID
                  )"
                  :key="
                    item.prodRecipeMain.StationLineID +
                    '_copy_' +
                    itemStation.prodRecipeMain.StationLineID
                  "
                  icon="el-icon-share"
                  @click="
                    copyToStationLine(
                      item.prodRecipeMain.StationLineID,
                      itemStation.prodRecipeMain.StationLineID,
                      2
                    )
                  "
                >
                  {{ itemStation.prodRecipeMain.StationLine }}
                </el-button>
              </el-row>
              <el-row
                :gutter="20"
                type="flex"
                justify="space-around"
                class="row-center"
              >
                <el-col>物资类型</el-col>
                <el-col>仓库</el-col>
                <el-col>物资</el-col>
                <el-col>规格</el-col>
                <el-col>理论用量（千克）</el-col>
                <el-col>实际用量（千克）</el-col>
                <el-col>含水率</el-col>
                <el-col>备注</el-col>
                <el-col>操作</el-col>
              </el-row>
              <el-row
                :gutter="20"
                type="flex"
                justify="space-around"
                v-for="(itemSub, index) in item.prodRecipeSubS"
                :key="index + '_S' + item.prodRecipeMain.StationLineID"
              >
                <el-col>
                  <el-form-item>
                    <el-select
                      v-model="itemSub.MatClassName"
                      @change="
                        recipeMappingSelectChange(
                          $event,
                          index,
                          item.prodRecipeMain.StationLineID,
                          2
                        )
                      "
                      :disabled="itemSub.IsManual == 0"
                      filterable
                    >
                      <el-option
                        v-for="mp in MaterialClassList"
                        :label="mp.MatClassName"
                        :key="
                          mp.MatClassID +
                          '_MatClassIDS_' +
                          index +
                          '_' +
                          item.prodRecipeMain.StationLineID
                        "
                        :value="mp.MatClassID"
                        v-model="mp.MatClassID"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-select
                      v-model="itemSub.WarehouseName"
                      @change="
                        recipeWhSelectChange(
                          $event,
                          index,
                          item.prodRecipeMain.StationLineID,
                          2
                        )
                      "
                      filterable
                    >
                      <el-option
                        v-for="wh in MappingGroupList.filter(
                          (e) =>
                            e.StationLineID == item.prodRecipeMain.StationLineID
                        ).filter((e) => e.MatClassID == itemSub.MatClassID)"
                        :label="wh.WarehouseName"
                        :key="
                          wh.Id +
                          '_WarehouseIDS_' +
                          index +
                          '_' +
                          item.prodRecipeMain.StationLineID
                        "
                        :value="wh.WarehouseID"
                        v-model="wh.WarehouseID"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-select
                      v-model="itemSub.MatName"
                      @change="
                        recipeMatSelectChange(
                          $event,
                          index,
                          item.prodRecipeMain.StationLineID,
                          2
                        )
                      "
                      filterable
                    >
                      <el-option
                        v-for="material in baseData.MaterialList &&
                        baseData.MaterialList.length > 0 &&
                        baseData.MaterialList.filter(
                          (e) => e.MatClassTypeCode == itemSub.MatTypeCode
                        ).length > 0
                          ? baseData.MaterialList.filter(
                              (e) => e.MatClassTypeCode == itemSub.MatTypeCode
                            )
                          : baseData.MaterialList"
                        :label="material.Name + '(' + material.MatGrade + ')'"
                        :key="
                          material.Id +
                          '_materialS_' +
                          index +
                          '' +
                          item.prodRecipeMain.StationLineID
                        "
                        :value="material.Id"
                        v-model="material.Id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-model="itemSub.MatGrade"
                      auto-complete="off"
                      readonly=""
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-model="itemSub.Quantity"
                      auto-complete="off"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-if="itemSub.Quantity == itemSub.ActualQuantity"
                      v-model="itemSub.ActualQuantity"
                      auto-complete="off"
                      @input="
                        changequantity(item.prodRecipeMain.StationLineID, 2)
                      "
                      :readonly="
                        (itemSub.MatTypeCode == 30 ||
                          itemSub.MatTypeCode == 301 ||
                          itemSub.MatTypeCode == 302) &&
                        itemSub.MoistureContent > 0
                          ? true
                          : false
                      "
                    ></el-input>
                    <el-input
                      v-else
                      DangerColor="danger"
                      v-model="itemSub.ActualQuantity"
                      auto-complete="off"
                      @input="
                        changequantity(item.prodRecipeMain.StationLineID, 2)
                      "
                      :readonly="
                        (itemSub.MatTypeCode == 30 ||
                          itemSub.MatTypeCode == 301 ||
                          itemSub.MatTypeCode == 302) &&
                        itemSub.MoistureContent > 0
                          ? true
                          : false
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input
                      v-model="itemSub.MoistureContent"
                      auto-complete="off"
                      @input="
                        MoistureContentCalculation(
                          item.prodRecipeMain.StationLineID,
                          2
                        )
                      "
                      v-show="
                        (itemSub.MatTypeCode == 30 ||
                          itemSub.MatTypeCode == 301 ||
                          itemSub.MatTypeCode == 302) &&
                        itemSub.Quantity > 0
                          ? true
                          : false
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-input v-model="itemSub.Remark"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item style="text-align: center">
                    <el-button
                      type="danger"
                      @click="
                        recipeTableRemoveRow(
                          index,
                          item.prodRecipeMain.StationLineID,
                          2
                        )
                      "
                      v-show="itemSub.IsManual == 1"
                    >
                      删除
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-button
                  @click="
                    recipeTableAddRow(item.prodRecipeMain.StationLineID, 2)
                  "
                >
                  新增行
                </el-button>
              </el-row>
            </el-form>
            <el-form size="mini">
              <el-row
                :gutter="20"
                type="flex"
                justify="space-around"
                class="row-center"
              >
                <el-col>
                  <el-form-item label="砂率">
                    <el-input v-model="item.prodRecipeMain.SSL"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="水胶比">
                    <el-input v-model="item.prodRecipeMain.SSJB"></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="容重">
                    <el-input
                      v-model="item.prodRecipeMain.SBulkDensity"
                      readonly=""
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="F掺量">
                    <el-input
                      v-model="item.prodRecipeMain.SFProportion"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="K掺量">
                    <el-input
                      v-model="item.prodRecipeMain.SKProportion"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="A掺量">
                    <el-input
                      v-model="item.prodRecipeMain.SAProportion"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="isShowAddRecipe = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
          >
            提交
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 理论配比选择 -->
    <TableDataDialog
      title="理论配比选择"
      :visibleDiaInitQuery="visibleDiaInitQuery"
      :visibleDialog="visibleDialog"
      :queryMethod="queryData"
      :columns="{
        Title: {
          label: '配比名称',
        },
        IsPumping: {
          label: '是否泵送',
          filter: (item) => {
            return item.IsPumping == 1 ? '是' : '否';
          },
        },
        GradeName: {
          label: '强度等级',
        },
        RecipeType: {
          label: '配比类型',
          filter: (item) => {
            return item.RecipeType == 1 ? '混凝土' : '砂浆';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="setVisible"
      @callback="dialogCallback"
    ></TableDataDialog>
    <!-- 任务选择 -->
    <TableDataDialog
      title="任务选择"
      :visibleDialog="visibleTaskDialog"
      :queryMethod="queryTaskData"
      :columns="{
        Code: {
          label: '任务编号',
        },
        ClientName: {
          label: '客户名称',
        },
        ProjectName: {
          label: '工程名称',
        },

        ProjectPart: {
          label: '施工部位',
        },

        PlanDate: {
          label: '计划时间',
          filter: (item) => {
            return formatDate(item.PlanDate);
          },
        },
        GradeName: {
          label: '强度等级',
          filter: (item) => {
            return item.GradeName+'/'+(item.SpecMtlName==null?'':item.SpecMtlName)+'/'+item.WorkMethodName;
          },
        },
        PlanQuantity: {
          label: '计划方量',
        },
        Remark: {
          label: '备注',
        },
      }"
      @getDialogVisible="setTaskVisible"
      @callback="dialogTaskCallback"
    ></TableDataDialog>

    <!-- 详情 -->
    <el-dialog
      title="历史配比"
      :visible.sync="isShowRecipeHistryDetail"
      v-model="isShowRecipeHistryDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered" style="">
        <tr>
          <th>任务单</th>
          <td>{{ taskdM.Title }}-{{ taskdM.Code }}</td>
          <th>工程名称</th>
          <td>{{ taskdM.ProjectName }}</td>
        </tr>
        <tr>
          <th>施工部位</th>
          <td>{{ taskdM.ProjectPart }}</td>
          <th>备注</th>
          <td>{{ taskdM.Remark }}</td>
        </tr>
        <tr>
          <th>强度等级</th>
          <td>{{ taskdM.GradeName }}/{{ taskdM.SpecMtlName }}</td>
          <th>浇筑方式</th>
          <td>{{ taskdM.WorkMethodName }}</td>
        </tr>
        <tr>
          <th>坍 落 度</th>
          <td>{{ taskdM.TLD }}</td>
          <th>计划方量/距离</th>
          <td>{{ taskdM.PlanQuantity }} / {{ taskdM.Distance }}</td>
        </tr>
      </table>
      <span>
        {{ historyCurrentStationLineName }}
        <el-tag type="danger">只显示最近十条修改记录</el-tag>
      </span>
      <el-divider></el-divider>
      <el-collapse accordion v-model="showHistrySub">
        <el-collapse-item
          v-for="(item, index) in prodRecipeHistoryDetailList"
          :key="'History_' + index"
          :name="index"
        >
          <template slot="title">
            <el-tag
              type="success"
              v-if="
                item.prodRecipeSubT != null && item.prodRecipeSubT.length > 0
              "
            >
              混凝土:{{ item.prodRecipeMain.TConsultRecipeTitle }} A掺量:{{
                item.prodRecipeMain.TAProportion
              }}
              {{ item.prodRecipeMain.TTLD }}
            </el-tag>
            <el-tag
              type="info"
              v-if="
                item.prodRecipeSubS != null && item.prodRecipeSubS.length > 0
              "
            >
              砂浆配比:{{ item.prodRecipeMain.SConsultRecipeTitle }} A掺量:{{
                item.prodRecipeMain.SAProportion
              }}
              {{ item.prodRecipeMain.STLD }}
            </el-tag>
            <el-tag
              :type="item.prodRecipeMain.Transfer == 1 ? 'success' : 'warning'"
            >
              {{ item.prodRecipeMain.Transfer == 1 ? "已传送" : "未传送" }}
            </el-tag>
            <el-tag
              :type="item.prodRecipeMain.Status == -1 ? 'warning' : 'success'"
            >
              {{ item.prodRecipeMain.Status == -1 ? "已归档" : "未归档" }}
            </el-tag>
            <el-tag type="danger">
              创建时间:{{ item.prodRecipeMain.CreateTime }}
            </el-tag>

            <i class="header-icon el-icon-info"></i>
          </template>
          <div
            v-if="item.prodRecipeSubT != null && item.prodRecipeSubT.length > 0"
          >
            <h4>混凝土信息</h4>
            <table class="table-bordered" style="">
              <tr>
                <th>搅拌时间</th>
                <td>
                  {{ item.prodRecipeMain.TMixTime }}
                </td>
                <th>创建人</th>
                <td>{{ item.prodRecipeMain.CreateUser }}</td>
                <th>坍落度</th>
                <td>{{ item.prodRecipeMain.TTLD }}</td>
                <th>备注</th>
                <td>{{ item.prodRecipeMain.TRemark }}</td>
              </tr>
            </table>
            <h4>混凝土配比明细</h4>
            <el-table :data="item.prodRecipeSubT">
              <el-table-column
                prop="MatName"
                label="物资名称"
              ></el-table-column>
              <el-table-column
                prop="WarehouseName"
                label="仓库名称"
              ></el-table-column>
              <el-table-column
                prop="MatGrade"
                label="物资规格"
              ></el-table-column>
              <el-table-column
                prop="Quantity"
                label="理论用量"
              ></el-table-column>
              <el-table-column
                prop="ActualQuantity"
                label="实际用量"
              ></el-table-column>
            </el-table>
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    容重：{{ item.prodRecipeMain.TBulkDensity }}Kg 砂率：{{
                      item.prodRecipeMain.TSL
                    }}
                    水胶比：{{ item.prodRecipeMain.TSJB }} F：{{
                      item.prodRecipeMain.TFProportion
                    }}
                    K：{{ item.prodRecipeMain.TKProportion }} A：{{
                      item.prodRecipeMain.TAProportion
                    }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div
            v-if="item.prodRecipeSubS != null && item.prodRecipeSubS.length > 0"
          >
            <h4>砂浆信息</h4>
            <table class="table-bordered" style="">
              <tr>
                <th>搅拌时间</th>
                <td>
                  {{ item.prodRecipeMain.SMixTime }}
                </td>
                <th>坍落度</th>
                <td>{{ item.prodRecipeMain.STLD }}</td>
                <th>创建人</th>
                <td>{{ item.prodRecipeMain.CreateUser }}</td>
                <th>备注</th>
                <td>{{ item.prodRecipeMain.SRemark }}</td>
              </tr>
            </table>
            <h4>砂浆配比明细</h4>
            <el-table :data="item.prodRecipeSubS">
              <el-table-column
                prop="MatName"
                label="物资名称"
              ></el-table-column>
              <el-table-column
                prop="WarehouseName"
                label="仓库名称"
              ></el-table-column>
              <el-table-column
                prop="MatGrade"
                label="物资规格"
              ></el-table-column>
              <el-table-column
                prop="Quantity"
                label="理论用量"
              ></el-table-column>
              <el-table-column
                prop="ActualQuantity"
                label="实际用量"
              ></el-table-column>
            </el-table>
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    容重：{{ item.prodRecipeMain.SBulkDensity }}Kg 砂率：{{
                      item.prodRecipeMain.TSL
                    }}
                    水胶比：{{ item.prodRecipeMain.SSJB }} F：{{
                      item.prodRecipeMain.TFProportion
                    }}
                    K：{{ item.prodRecipeMain.SKProportion }} A：{{
                      item.prodRecipeMain.SAProportion
                    }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </section>
</template>

<script>
//引入projectPart.js的所有export的对象,并起别名为api,通过api.***访问成员
import { sendTask, getGetRecipeTask } from "../../api/RecipeMappingTask";
import {
  getConsultRecipeListPage,
  getConsultRecipeDetail,
} from "../../api/recipe";
import { getProdTaskListPage } from "../../api/prodTask";
import * as api from "../../api/prodRecipe";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";
import { jsonp } from "vue-jsonp";
export default {
  components: {
    Toolbar,
    TableDataDialog,
  },
  data() {
    return {
      currentRow: null,
      filters: {
        key: "",
        orgCode: "",
        startTime: "",
        endTime: "",
        isRecipe: 100,
        gradeName: "",
        page: 1,
        intPageSize: 10,
        taskStatus: -1,
      },
      dataList: [],
      recipepage: 1,
      orgList: JSON.parse(localStorage.sysOrgs),
      total: 0,
      addLoading: false,
      listLoading: false,
      sels: [], //列表选中列
      taskdM: {},
      isShowDetail: false, //任务单详情
      isShowAddRecipe: false, //配比编辑添加页面打开
      stationLine: [], //当前所有生产线
      baseData: [], //基础数据
      MappingGroupList: [], //配比映射
      MaterialClassList: [], //配比映射物资类型分组
      editableTabsValue: "", //当前生产线Tab名称
      editableTabs: [], //生产线以及生产线下的配比信息
      subIndex: 1,
      checkboxStationLine: [], //当前配比所选择中的生产线
      isEdit: false,
      visibleDialog: false, //理论配比选择页面打开
      visibleDiaInitQuery: "", //理论配比页面传入默认查询条件
      openType: 1, //打开选择理论配比类型：1混凝土 2 砂浆
      currStationLineID: "", //当前选择配比的生产线
      visibleTaskDialog: false, //任务单列表选择
      isShowRecipeHistryDetail: false, //历史配比详情
      prodRecipeHistoryDetailList: [], //配比历史信息
      historyCurrentStationLineName: "", //历史配比所属生产线
      isCopyTask: false, //是否为复制的任务单
      showHistrySub: [0], //默认展开历史记录中的第一条
    };
  },
  computed: {},
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getTaskList();
    },
    // 显示任务详情
    handleTaskDetail(row) {
      this.taskdM = row;
      this.isShowDetail = !this.isShowDetail;
    },
    // 显示任务详情
    showRecipeHistry(prodRecipeMain) {
      this.taskdM = this.currentRow;
      this.isShowRecipeHistryDetail = !this.isShowRecipeHistryDetail;
      let para = { recipeCode: prodRecipeMain.Code };
      this.listLoading = true;
      this.prodRecipeHistoryDetailList = [];
      this.historyCurrentStationLineName = prodRecipeMain.StationLine;
      api.getHistryByPage(para).then((res) => {
        this.prodRecipeHistoryDetailList = res.data.response;
        this.listLoading = false;
      });
    },

    dialogTaskCallback(data) {
      if (data.length > 0) {
        this.taskdM = data[0];
      }
      this.visibleTaskDialog = false;
    },
    queryTaskData(params) {
      let taskparams = {
        page: params.page,
        key: params.key,
        intPageSize: params.intPageSize,
      };
      return getProdTaskListPage(taskparams);
    },
    setTaskVisible(val) {
      this.visibleTaskDialog = val;
    },
    //添加配比信息
    addProdRecipe() {
      if (this.stationLine == null || this.stationLine.length == 0) {
        this.getBaseData();
      }
      this.isCopyTask = false;
      this.taskdM = this.currentRow;
      this.isShowAddRecipe = true;
      let para = {
        taskId: this.taskdM.Id,
      };
      this.editableTabs = [];
      this.editableTabsValue = "";
      this.checkboxStationLine = [];
      api.getProdRecipeListPage(para).then((res) => {
        if (res.data.response && res.data.response.length > 0) {
          this.editableTabs = res.data.response;
          this.editableTabsValue =
            res.data.response[0].prodRecipeMain.StationLine;
          res.data.response.map((k) => {
            this.checkboxStationLine.push(k.prodRecipeMain.StationLine);
          });
        }
      });
    },
    //复制任务配比
    copyProdRecipe() {
      this.isCopyTask = true;
      this.isShowAddRecipe = true;
      this.taskdM = {};
      let para = {
        taskId: this.currentRow.Id,
      };
      this.editableTabs = [];
      this.editableTabsValue = "";
      this.checkboxStationLine = [];
      api.getProdRecipeListPage(para).then((res) => {
        if (res.data.response && res.data.response.length > 0) {
          this.editableTabs = res.data.response;
          this.editableTabsValue =
            res.data.response[0].prodRecipeMain.StationLine;
          res.data.response.map((k) => {
            this.checkboxStationLine.push(k.prodRecipeMain.StationLine);
          });
        }
      });
    },
    copyToStationLine(souceStationLineId, targetStationLineId, opType) {
      let souceprodrecipeSub;
      if (opType == 1) {
        souceprodrecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID === souceStationLineId
        )[0].prodRecipeSubT;
      } else {
        souceprodrecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID === souceStationLineId
        )[0].prodRecipeSubS;
      }

      if (souceprodrecipeSub != null && souceprodrecipeSub.length > 0) {
        if (opType == 1) {
          this.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == targetStationLineId
          )[0].prodRecipeSubT = JSON.parse(JSON.stringify(souceprodrecipeSub));
          //赋值后重新初始化一次物资类型
          this.editableTabs
            .filter(
              (e) => e.prodRecipeMain.StationLineID == targetStationLineId
            )[0]
            .prodRecipeSubT.map((e, index) => {
              this.recipeMappingSelectChange(
                e.MatClassID,
                index,
                targetStationLineId,
                opType
              );
            });
        } else {
          this.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == targetStationLineId
          )[0].prodRecipeSubS = JSON.parse(JSON.stringify(souceprodrecipeSub));
          //赋值后重新初始化一次物资类型
          this.editableTabs
            .filter(
              (e) => e.prodRecipeMain.StationLineID == targetStationLineId
            )[0]
            .prodRecipeSubS.map((e, index) => {
              this.recipeMappingSelectChange(
                e.MatClassID,
                index,
                targetStationLineId,
                opType
              );
            });
        }
      }
      //子表赋值End
      let souceProdRecipeMain = this.editableTabs.filter(
        (e) => e.prodRecipeMain.StationLineID == souceStationLineId
      )[0].prodRecipeMain;
      let souceMain = JSON.parse(JSON.stringify(souceProdRecipeMain));
      let targetMain = this.editableTabs.filter(
        (e) => e.prodRecipeMain.StationLineID == targetStationLineId
      )[0].prodRecipeMain;
      //主表赋值
      if (opType == 1) {
        this.$set(targetMain, "TID", souceMain.TID);
        this.$set(
          targetMain,
          "TConsultRecipeTitle",
          souceMain.TConsultRecipeTitle
        );
        this.$set(targetMain, "TMixTime", souceMain.TMixTime);
        this.$set(targetMain, "TBulkDensity", souceMain.TBulkDensity);
        this.$set(targetMain, "TTLD", souceMain.TTLD);
        this.$set(targetMain, "TSL", souceMain.TSL);
        this.$set(targetMain, "TSJB", souceMain.TSJB);
        this.$set(targetMain, "TFProportion", souceMain.TFProportion);
        this.$set(targetMain, "TKProportion", souceMain.TKProportion);
        this.$set(targetMain, "TAProportion", souceMain.TAProportion);
        this.$set(targetMain, "TRemark", souceMain.TRemark);
      } else {
        this.$set(targetMain, "SID", souceMain.SID);
        this.$set(
          targetMain,
          "SConsultRecipeTitle",
          souceMain.SConsultRecipeTitle
        );
        this.$set(targetMain, "SMixTime", souceMain.SMixTime);
        this.$set(targetMain, "SBulkDensity", souceMain.SBulkDensity);
        this.$set(targetMain, "STLD", souceMain.STLD);
        this.$set(targetMain, "SSL", souceMain.SSL);
        this.$set(targetMain, "SSJB", souceMain.SSJB);
        this.$set(targetMain, "SFProportion", souceMain.SFProportion);
        this.$set(targetMain, "SKProportion", souceMain.SKProportion);
        this.$set(targetMain, "SAProportion", souceMain.SAProportion);
        this.$set(targetMain, "SRemark", souceMain.SRemark);
      }
      let currenStation = this.stationLine.filter(
        (e) => e.Id == targetStationLineId
      )[0];
      //主表赋值
      //切换生产线显示
      this.editableTabsValue = currenStation.Name;
    },
    selectOrg() {
      this.getBaseData();
      this.getTaskList(1);
    },
    //获取列表
    getTaskList(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      getGetRecipeTask(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.dataList = res.data.response.data;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行新增
    addSubmit() {
      this.addLoading = true;
      if (!this.taskdM.Id) {
        this.$message({
          message: "请选择一个任务单再进行保存操作",
          type: "error",
        });
        this.addLoading = false;
        return;
      }
      let para = {
        prodTask: this.taskdM,
        recipeList: this.editableTabs,
      };
      let user = JSON.parse(window.localStorage.user);

      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .addProdRecipe(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.isShowAddRecipe = false;
            this.getTaskList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.addLoading = false;
        });
    },
    //单条生产线配比上传
    sendRecipe(item) {
      let para = {
        recipeId: item.Id,
      };

      api.sendRecipe(para).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          item.Transfer = 1;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
          this.getTaskList();
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getTaskList(1);
    },
    //获取配比所需基础信息
    getBaseData() {
      let para = {
        orgCode: this.filters.orgCode,
      };
      api.getProdRecipeBaseData(para).then((res) => {
        this.baseData = res.data.response;
        this.stationLine = res.data.response.SysStationLineList;
        this.MappingGroupList = res.data.response.SysRecipeMappingList;
        this.MaterialClassList = res.data.response.MaterialClassList;
      });
    },
    addTab(targetId, isTrue) {
      let stationItem = this.stationLine.filter((e) => e.Id === targetId);
      if (stationItem && stationItem.length > 0) {
        if (isTrue) {
          //添加此生产线
          this.editableTabs.push({
            prodRecipeMain: {
              TMixTime: 0,
              SMixTime: 0,
              StationLineID: stationItem[0].Id,
              StationLine: stationItem[0].Name,
            },
            prodRecipeSubT: [], //混凝土子条目
            prodRecipeSubS: [], //砂浆子条目
          });
          this.editableTabsValue = stationItem[0].Name;
        } else {
          //删除此生产线
          let tabs = this.editableTabs;
          this.editableTabs = tabs.filter(
            (tab) => tab.prodRecipeMain.StationLineID !== stationItem[0].Id
          );
          if (this.editableTabs && this.editableTabs.length > 0) {
            this.editableTabsValue = this.editableTabs[
              this.editableTabs.length - 1
            ].prodRecipeMain.StationLine;
          }
        }
      }
    },
    //混凝土物资类型选择opType:1为混凝土,opType:2为砂浆
    recipeMappingSelectChange(Id, index, StationLineID, opType) {
      let mappingItem = this.MappingGroupList.filter(
        (e) => e.MatClassID == Id && e.StationLineID == StationLineID
      )[0];
      let itemProdRecipeSub = null;
      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT[index];
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS[index];
      }
      this.$set(itemProdRecipeSub, "MatClassID", mappingItem.MatClassID);
      this.$set(itemProdRecipeSub, "WarehouseID", mappingItem.WarehouseID);
      this.$set(itemProdRecipeSub, "WarehouseName", mappingItem.WarehouseName);
      this.$set(itemProdRecipeSub, "MatClassName", mappingItem.MatClassName);
      var matItem = this.baseData.MaterialList.filter(
        (e) => e.MatClassID == mappingItem.MatClassID
      )[0];

      if (
        this.baseData.sysRecipeMappingList &&
        this.baseData.sysRecipeMappingList.length > 0
      ) {
        var itemsysRecipeMapping = this.baseData.sysRecipeMappingList.filter(
          (k) =>
            k.WarehouseID == mappingItem.WarehouseID &&
            k.StationLineID == StationLineID
        );
        if (
          itemsysRecipeMapping &&
          itemsysRecipeMapping.length > 0 &&
          itemsysRecipeMapping[0].MatID > 0
        ) {
          var material = this.baseData.MaterialList.filter(
            (e) => e.Id == itemsysRecipeMapping[0].MatID
          );
          if (material != null && material.length > 0) {
            matItem = material[0];
          }
        }
      }
      if (matItem) {
        this.$set(itemProdRecipeSub, "MatTypeCode", matItem.MatClassTypeCode);
        this.$set(itemProdRecipeSub, "MatID", matItem.Id);
        this.$set(itemProdRecipeSub, "MatName", matItem.Name);
        this.$set(itemProdRecipeSub, "MatGrade", matItem.MatGrade);
      } else {
        this.$set(itemProdRecipeSub, "MatTypeCode", null);
        this.$set(itemProdRecipeSub, "MatID", null);
        this.$set(itemProdRecipeSub, "MatName", null);
        this.$set(itemProdRecipeSub, "MatGrade", null);
      }
    },
    //仓库选择opType:1为混凝土,opType:2为砂浆
    recipeWhSelectChange(Id, index, StationLineID, opType) {
      let itemProdRecipeSub = null;
      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT[index];
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS[index];
      }
      itemProdRecipeSub.WarehouseID = this.MappingGroupList.filter(
        (x) => x.WarehouseID == Id
      )[0].WarehouseID;
      itemProdRecipeSub.WarehouseName = this.MappingGroupList.filter(
        (x) => x.WarehouseID == Id
      )[0].WarehouseName;
    },
    //配比物资选择opType:1为混凝土,opType:2为砂浆
    recipeMatSelectChange(Id, index, StationLineID, opType) {
      let itemProdRecipeSub = null;
      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT[index];
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS[index];
      }
      itemProdRecipeSub.MatGrade = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].MatGrade;
      itemProdRecipeSub.MatTypeCode = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].MatClassTypeCode;
      itemProdRecipeSub.MatName = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].Name;
      itemProdRecipeSub.MatID = Id;
    },
    //计算容重比例,opType:1为混凝土,opType:2为砂浆
    changequantity(StationLineID, opType) {
      /* 
    砂率=砂/骨料、水胶比=水/粉料、F掺量=粉煤灰/粉料、K掺量=矿粉/粉料、A掺量=外加剂/粉料。 
    材料类型码：
    水：10，
    备用：20，
    骨料：30，砂子：301，石子：302
    粉料：40，水泥：401，粉煤灰：402，矿粉：403，
    外加剂：50
    */
      //-------- 计算比例 开始
      var warterTotal = 0; //水
      var sandTotal = 0; //砂
      var cementTotal = 0; //水泥
      var flyashTotal = 0; //粉煤灰
      var breezeTotal = 0; //矿粉
      var additiveTotal = 0; //外加剂
      var powderTotal = 0; //粉料
      var aggregateTotal = 0; //骨料
      var bulkDensity = 0; //容重
      let itemProdRecipeSub = null;
      let itemProdRecipeMain = null;
      itemProdRecipeMain = this.editableTabs.filter(
        (e) => e.prodRecipeMain.StationLineID == StationLineID
      )[0].prodRecipeMain;
      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT;
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS;
      }
      itemProdRecipeSub.map((e) => {
        var matItem = this.baseData.MaterialList.filter(
          (k) => k.Id == e.MatID
        )[0];
        var quantity =
          e.ActualQuantity == "" || e.ActualQuantity == undefined
            ? 0
            : Number(e.ActualQuantity);
        bulkDensity += quantity;
        var typeCode =
          matItem != null && matItem != undefined
            ? matItem.MatClassTypeCode
            : "";
        if (typeCode == "" || typeCode == null) {
          return;
        } else {
          if (typeCode.indexOf("1") == 0) {
            warterTotal += Number(quantity);
          } else if (typeCode.indexOf("2") == 0) {
          } else if (typeCode.indexOf("3") == 0) {
            aggregateTotal += Number(quantity);

            if (typeCode == "301") {
              sandTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("4") == 0) {
            powderTotal += Number(quantity);

            if (typeCode == "401") {
              cementTotal += Number(quantity);
            }
            if (typeCode == "402") {
              flyashTotal += Number(quantity);
            }
            if (typeCode == "403") {
              breezeTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("5") == 0) {
            additiveTotal += Number(quantity);
          }
        }
      });
      if (opType == 1) {
        itemProdRecipeMain.TSL = (aggregateTotal == 0
          ? 0
          : sandTotal / aggregateTotal
        ).toFixed(4); //砂率
        itemProdRecipeMain.TSJB = (powderTotal == 0
          ? 0
          : warterTotal / powderTotal
        ).toFixed(4); //水胶比
        itemProdRecipeMain.TFProportion = (powderTotal == 0
          ? 0
          : flyashTotal / powderTotal
        ).toFixed(4); //F掺量
        itemProdRecipeMain.TKProportion = (powderTotal == 0
          ? 0
          : breezeTotal / powderTotal
        ).toFixed(4); //K掺量
        itemProdRecipeMain.TAProportion = (powderTotal == 0
          ? 0
          : additiveTotal / powderTotal
        ).toFixed(4); //A掺量
        itemProdRecipeMain.TBulkDensity = bulkDensity;
      } else {
        itemProdRecipeMain.SSL = (aggregateTotal == 0
          ? 0
          : sandTotal / aggregateTotal
        ).toFixed(4); //砂率
        itemProdRecipeMain.SSJB = (powderTotal == 0
          ? 0
          : warterTotal / powderTotal
        ).toFixed(4); //水胶比
        itemProdRecipeMain.SFProportion = (powderTotal == 0
          ? 0
          : flyashTotal / powderTotal
        ).toFixed(4); //F掺量
        itemProdRecipeMain.SKProportion = (powderTotal == 0
          ? 0
          : breezeTotal / powderTotal
        ).toFixed(4); //K掺量
        itemProdRecipeMain.SAProportion = (powderTotal == 0
          ? 0
          : additiveTotal / powderTotal
        ).toFixed(4); //A掺量
        itemProdRecipeMain.SBulkDensity = bulkDensity;
      }
    },
    //混凝土计算含水率,opType:1为混凝土,opType:2为砂浆
    MoistureContentCalculation(StationLineID, opType) {
      let itemProdRecipeSub = null;
      let recipeName = "混凝土";

      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT;
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS;
        recipeName = "砂浆";
      }
      var moistureContentCount = 0;
      //循环混凝土子条目
      itemProdRecipeSub.map((e) => {
        var moistureContent = parseFloat(e.MoistureContent);
        moistureContent = moistureContent / 100;
        var typeCode = e.MatTypeCode;
        // 含水率:MoistureContent
        if (
          (Number(typeCode) == 30 ||
            Number(typeCode) == 301 ||
            Number(typeCode) == 302) &&
          Number(e.Quantity) > 0
        ) {
          var Quantity = e.Quantity;
          if (moistureContent >= 1) {
            e.MoistureContent = 0;
            moistureContent = 0;
          }
          //实际用量 = 参考用量 /（1-含水率[小于1]）
          e.ActualQuantity = (Quantity / (1 - moistureContent)).toFixed(2);

          //水的重量 = 实际用量 * 含水率
          var ActualQuantity = e.ActualQuantity;
          moistureContentCount += moistureContent * ActualQuantity;
        }
      });

      var resultContent =
        recipeName + "配方总含水为：" + moistureContentCount.toFixed(2);

      var _arrayList = new Array();
      itemProdRecipeSub.map((e) => {
        var TypeCode = e.MatTypeCode;
        if (Number(TypeCode) == 10) {
          var Quantity = parseFloat(e.Quantity);
          _arrayList.push(Quantity);
        }
      });
      if (_arrayList != null) {
        for (var i = 0; i < _arrayList.length; i++) {
          for (var u = i + 1; u < _arrayList.length; u++) {
            if (parseFloat(_arrayList[i]) > parseFloat(_arrayList[u])) {
              var num = [];
              num = _arrayList[i];
              _arrayList[i] = _arrayList[u];
              _arrayList[u] = num;
            }
          }
        }
        for (var j = _arrayList.length - 1; j >= 0; j--) {
          itemProdRecipeSub.map((e) => {
            var TypeCode = e.MatTypeCode;
            if (Number(moistureContentCount) > 0) {
              // 含水率:MoistureContent
              var Quantity = parseFloat(e.Quantity);
              //（清水）实际用量 = 参考用量 - （所有砂子石子中）水的重量
              if (
                Number(TypeCode) == 10 &&
                parseFloat(_arrayList[j]) == Quantity
              ) {
                var deductionWater = 0;
                //如果参考用量小于含水，则实际用量设置为0
                if (moistureContentCount > Quantity) {
                  moistureContentCount -= Quantity;
                  e.ActualQuantity = 0;
                  deductionWater = Quantity;
                } else {
                  var ActualQuantity = (
                    Quantity - moistureContentCount
                  ).toFixed(2);
                  deductionWater = moistureContentCount;
                  moistureContentCount = 0;
                  e.ActualQuantity = ActualQuantity;
                }
                resultContent +=
                  "仓库：" +
                  e.WarehouseName +
                  "-物资:" +
                  e.MatName +
                  "扣水" +
                  deductionWater.toFixed(2);
                _arrayList[j] = -1;
              }
            } else if (Number(TypeCode) == 10) {
              e.ActualQuantity = e.Quantity;
            }
          });
        }
      }
      if (moistureContentCount > 0) {
        this.$message({
          message: recipeName + "待扣水：" + moistureContentCount.toFixed(2),
          type: "warning",
        });
      }
      this.$message({
        message: resultContent,
        type: "success",
      });
    },
    //配方明细删除行,opType:1为混凝土,opType:2为砂浆
    recipeTableRemoveRow(index, StationLineID, opType) {
      let itemProdRecipeSub = null;
      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT;
        itemProdRecipeSub.splice(index, 1);
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS;
        itemProdRecipeSub.splice(index, 1);
      }

      this.changequantity(StationLineID, opType);
    },
    //配方明细添加行,opType:1为混凝土,opType:2为砂浆
    recipeTableAddRow(StationLineID, opType) {
      this.subIndex += 1;
      let itemProdRecipeSub = null;
      if (opType == 1) {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubT;
      } else {
        itemProdRecipeSub = this.editableTabs.filter(
          (e) => e.prodRecipeMain.StationLineID == StationLineID
        )[0].prodRecipeSubS;
      }

      itemProdRecipeSub.push({
        Id: this.subIndex,
        IsManual: 1,
        RecipeType: opType,
      });
    },
    queryData(params) {
      params.recipeType = this.openType;
      if (this.recipepage == 1) {
        this.recipepage = 2;
        params.page = 1;
      }
      params.StationLineID = this.currStationLineID;
      return getConsultRecipeListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
      if (!val) {
        this.visibleDiaInitQuery = null;
      }
    },
    //回调理论配比
    dialogCallback(data) {
      if (data.length > 0) {
        this.getConsultRecipeDetailById(data[0].Id);
      }
      this.visibleDialog = false;
    },
    dialogType(type, StationLineID) {
      this.recipepage = 1;
      if (type == 1) {
        this.visibleDiaInitQuery = this.taskdM.GradeName;
      } else {
        this.visibleDiaInitQuery = "";
      }

      this.visibleDialog = true;
      this.openType = type;
      this.currStationLineID = StationLineID;
    },
    //基础配比回调
    getConsultRecipeDetailById(Id) {
      let para = {
        id: Id,
      };
      getConsultRecipeDetail(para).then((res) => {
        var that = this;
        let itemProdRecipeSub = [];

        let value = res.data.response.ConsultRecipeSubList,
          consultRecipe = res.data.response.ConsultRecipe;
        value.map((v, index) => {
          var mappingItem = that.MappingGroupList.filter(
            (m) =>
              m.MatClassID == v.MatClassID &&
              m.StationLineID == that.currStationLineID
          )[0];
          var mappingWh = that.MappingGroupList.filter(
            (m) =>
              m.WarehouseID == v.WarehouseID &&
              m.StationLineID == that.currStationLineID
          );
          var matItem = that.baseData.MaterialList.filter(
            (mat) => mat.MatClassID == v.MatClassID
          )[0];
          if (
            this.baseData.sysRecipeMappingList &&
            this.baseData.sysRecipeMappingList.length > 0 &&
            mappingWh &&
            mappingWh.length > 0
          ) {
            var itemsysRecipeMapping = this.baseData.sysRecipeMappingList.filter(
              (k) =>
                k.WarehouseID == mappingWh[0].WarehouseID &&
                k.StationLineID == that.currStationLineID
            );

            if (
              itemsysRecipeMapping &&
              itemsysRecipeMapping.length > 0 &&
              itemsysRecipeMapping[0].MatID > 0
            ) {
              var material = this.baseData.MaterialList.filter(
                (e) => e.Id == itemsysRecipeMapping[0].MatID
              );
              if (material != null && material.length > 0) {
                matItem = material[0];
              }
            }
          }
          that.subIndex = that.subIndex + 1;

          itemProdRecipeSub.push({
            Id: that.subIndex,
            MatClassID: v.MatClassID,
            MatClassName: v.MatClassName,
            IsManual: 0,
            WarehouseID:
              mappingWh && mappingWh.length > 0
                ? mappingWh[0].WarehouseID
                : mappingItem
                ? mappingItem.WarehouseID
                : "",
            WarehouseName:
              mappingWh && mappingWh.length > 0
                ? mappingWh[0].WarehouseName
                : mappingItem
                ? mappingItem.WarehouseName
                : "",
            Quantity: v.Quantity,
            ActualQuantity: v.Quantity,
            MatGrade: matItem ? matItem.MatGrade : "",
            MatID: matItem ? matItem.Id : "",
            MatName: matItem ? matItem.Name : "",
            MatTypeCode: matItem ? matItem.MatClassTypeCode : "",
            MoistureContent: 0,
            RecipeType: this.openType,
          });
        });

        if (this.openType == 1) {
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeSubT = itemProdRecipeSub;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.TID = consultRecipe.Id;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.TConsultRecipeTitle = consultRecipe.Title;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.TMixTime = consultRecipe.MixingTime;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.TTLD = consultRecipe.TLD;
        } else {
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeSubS = itemProdRecipeSub;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.SID = consultRecipe.Id;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.SConsultRecipeTitle = consultRecipe.Title;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.SMixTime = consultRecipe.MixingTime;
          that.editableTabs.filter(
            (e) => e.prodRecipeMain.StationLineID == that.currStationLineID
          )[0].prodRecipeMain.STLD = consultRecipe.TLD;
        }
        this.$forceUpdate();
        this.changequantity(that.currStationLineID, that.openType);
      });
    },
    formatDateYMD(date) {
      function padZero(num) {
        return num < 10 ? "0" + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  },
  mounted() {
    /*获取任务单基础档案*/
    if (localStorage.currentOrg) {
      this.filters.orgCode = JSON.parse(localStorage.currentOrg).OrgCode;
    } else if (localStorage.sysOrgs) {
      this.filters.orgCode = JSON.parse(localStorage.sysOrgs)[0].OrgCode;
    }
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDateYMD(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate() + 1); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDateYMD(endDate);

    /*获取任务单基础档案*/
    this.getTaskList();
    this.getBaseData();

    // let routers = window.localStorage.router
    //   ? JSON.parse(window.localStorage.router)
    //   : [];
    // this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped>
.stationline-card {
  padding: 5px;
  width: 220px;
  height: 75px;
  background: #fff;
  border-radius: 3px;
  border: 1px solid #ccc;
  float: left;
  margin-right: 5px;
}

/deep/.el-input__inner[DangerColor="danger"] {
  color: #f56c6c; //红色
}

/deep/.el-input__inner[WarningColor="warning"] {
  color: #e6a23c; //橙色
}

/deep/.el-input__inner[SuccessColor="success"] {
  color: #67c23a; //绿色
}
</style>
